import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
// Graphql
import { client_EB_api } from "../../graphql/client";
import { GET_ALL_NEIGHBORHOODS } from "../../graphql";
// SCSS
import "../CountrySelect/CountrySelect.scss";
import SelectInput from "../SelectInput/SelectInput";

function NeighborhoodSelect({
  value,
  name,
  onChange,
  label,
  disabled,
  className,
  district,
}) {
  const [neighborhoods, setNeighborhoods] = useState([]);

  const getDistricts = useCallback(async () => {
    const { data } = await client_EB_api.query({
      query: GET_ALL_NEIGHBORHOODS,
      variables: {
        FK_District: district,
      },
    });
    setNeighborhoods(data.neighborhoods);
  }, [district]);

  useEffect(() => {
    getDistricts();
  }, [getDistricts]);

  return (
    <SelectInput
      data={neighborhoods}
      disabled={disabled}
      name={name}
      value={value}
      onChange={e => onChange(e.target.name, e.target.value)}
    />
  );
}

NeighborhoodSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  district: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

NeighborhoodSelect.defaultProps = {
  disabled: false,
  className: "",
};

export default NeighborhoodSelect;
